import React from "react";
import SidebarView from "./sidebarView";

const sidebarContainer = () => {
  return <SidebarView />;
};

export default sidebarContainer;
